import {
  IArpFavoritedNotification,
  IArpUsedNotification,
  IMintCompletedNotification,
  NotificationModel
} from '@arpeggi/shared'

export type ArpUsedNotificationType = Omit<NotificationModel, 'data'> & {
  data: IArpUsedNotification
}

export type MintCompletedNotificationType = Omit<NotificationModel, 'data'> & {
  data: IMintCompletedNotification
}

export type ArpFavoritedNotificationType = Omit<NotificationModel, 'data'> & {
  data: IArpFavoritedNotification
}
